

import React, { useState, useEffect,useMemo } from "react";
import axios from "axios";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Stack,DialogActions,
  Pagination,
  Button,
} from "@mui/material";
import ExcelJS from "exceljs";

import loadergif from "../../../assets/images/BG-switch loader_2.gif";

import Typography from "@mui/material/Typography";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import {  VAVE,GETIL5DATA,DOWNLOADUPLOADEDUSERFILE,DOWNLOADIL5FILE } from "../../../Pages/AppConstant";
import * as XLSX from "xlsx";

import approvedImage from "../../../assets/images/approved_image.jpg";
import rejectedImage from "../../../assets/images/rejected_image.jpg";
import DownloadIcon from "@mui/icons-material/Download";

const isEmpty = (v) => v == null || String(v).trim() === "";

// Color mapping
const getStatusColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "accepted":
      return "green";
    case "rejected":
      return "red";
    case "pending":
    case "inprogress":
      return "orange";
    default:
      return "gray";
  }
};


const getPDOverallStatus = (r) => {
  if (String(r.checked_status).toLowerCase() === "rejected") return "rejected";
   else if (String(r.checked_status).toLowerCase() === "accepted") return "accepted";
 else if (String(r.checked_status).toLowerCase() === "inprogress") return "pending";


 
};

const getQualityOverallStatus = (r) => {
  if (String(r.approved_status).toLowerCase() === "rejected") return "rejected";
   else if (String(r.approved_status).toLowerCase() === "accepted") return "accepted";
 else if (String(r.approved_status).toLowerCase() === "inprogress") return "pending";
};



const StatusDot = ({ status, name, onClick }) => (
  <Tooltip title={`Status: ${status} (${name})`} arrow>
    <span
      onClick={onClick}
      style={{
        display: "inline-block",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        backgroundColor: getStatusColor(status),
        margin: "auto",
        cursor: "pointer",
      }}
    />
  </Tooltip>
);

const IdeaTable = () => {
  const [allIdeas, setAllIdeas] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedApprover, setSelectedApprover] = useState(null);

  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);

  const [isloading, setIsloading] = useState(false);

  const itemsPerPage = 10;

  // ---------------------------
  // API: Fetch ideas
  // ---------------------------
  const fetchIdeas = async () => {
    try {
      const response = await axios.get(VAVE + GETIL5DATA, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response?.data?.data || [];
      setAllIdeas(ideas);
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  // ---------------------------
  // File download
  // ---------------------------
  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request?.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response?.data?.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType = response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request?.idea_unique_id || request?.id_x}_User_Document.pdf`;

        // If server sent filename in headers
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) filename = decodeURIComponent(match[1]);
        }

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch(() => {
        // Fallback: open stored file path if available
        const fallback = request?.filepath || selectedIdea?.filepath;
        if (fallback) window.open(fallback, "_blank");
        setIsloading(false);
      });
  };

  // ---------------------------
  // Enrich rows with computed PD/Quality approvers
  // ---------------------------
  const updatedRequests = useMemo(() => {
    return (allIdeas || []).map((req) => {
      const approvers = [
        {
          role: "CHECKED",
          name: req?.checked_by || "-",
          status: getPDOverallStatus(req), 
        },
        {
          role: "APPROVED",
          name: req?.approved_by || "-",
          status: getQualityOverallStatus(req),
        },
      ];
      return { ...req, approvers };
    });
  }, [allIdeas]);


  // const filteredIdeas = useMemo(() => {
  //   const q = (searchQuery || "").toLowerCase();
  //   if (!q) return updatedRequests;

  //   return updatedRequests.filter((item) =>
  //     Object.values(item).some((value) => String(value).toLowerCase().includes(q))
  //   );
  // }, [searchQuery, updatedRequests]);

  const filteredIdeas = Array.isArray(updatedRequests)
  ? updatedRequests.filter((item) => {
      const query = searchQuery.toLowerCase();
      return Object.values(item).some((value) =>
        String(value).toLowerCase().includes(query)
      );
    })
  : [];


  const totalPages = Math.ceil((filteredIdeas?.length || 0) / itemsPerPage);
  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // ---------------------------
  // Status Summary Counts
  // ---------------------------
  const counts = useMemo(() => {
    const list = updatedRequests;
    const norm = (s) => (s || "").toString().trim().toLowerCase();

    const checkedApproved = list.filter((i) => norm(getPDOverallStatus(i)) === "accepted").length;
    const checkedPending = list.filter((i) => norm(getPDOverallStatus(i)) === "pending").length;
    const checkedRejected = list.filter((i) => norm(getPDOverallStatus(i)) === "rejected").length;

    const approvedApproved =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "accepted").length;
    const approvedPending =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "pending").length;
    const approvedRejected =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "rejected").length;

    return {
      checkedApproved,
      checkedPending,
      checkedRejected,
      approvedApproved,
      approvedPending,
      approvedRejected,
    };
  }, [updatedRequests]);

  // ---------------------------
  // UI Handlers
  // ---------------------------
  const handleDotClick = (req, approver) => {
    setSelectedRequest(req);
    setSelectedApprover(approver);
    setOpenDialog(true);
  };

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };

  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };


const downloadApi = async (request) => {
  try {
    setIsloading(true);

    const response = await axios({
      method: "post",
      url: VAVE + DOWNLOADIL5FILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.idea_id },
      responseType: "blob",
    });

    const blob = response.data;
    if (!blob || !(blob instanceof Blob)) {
      alert("Download failed: Invalid file response.");
      setIsloading(false);
      return;
    }

    const contentType = (response.headers["content-type"] || "").toLowerCase();

    const contentDisposition = response.headers["content-disposition"] || "";
    const fileNameFromHeader = (() => {
      const filenameStarMatch = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
      if (filenameStarMatch) {
        try {
          const v = filenameStarMatch[1].split("''")[1] || filenameStarMatch[1];
          return decodeURIComponent(v.replace(/["']/g, "").trim());
        } catch (_) {}
      }
      const filenameMatch = contentDisposition.match(/filename\s*=\s*([^;]+)/i);
      if (filenameMatch) {
        return filenameMatch[1].replace(/["']/g, "").trim();
      }
      return null;
    })();

  
    const baseName = `Idea_${request.idea_unique_id}_IL5_adminReport`;

 
    const isPdfByHeader = contentType.includes("application/pdf");

 
    const isExcelByHeader =
      contentType.includes(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ) ||
      contentType.includes("application/vnd.ms-excel") || 
      contentType.includes("application/octet-stream"); 

    const arrayBuffer = await blob.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);
    const magicIsPdf =
      bytes.length >= 4 &&
      bytes[0] === 0x25 &&
      bytes[1] === 0x50 &&
      bytes[2] === 0x44 &&
      bytes[3] === 0x46; // %PDF
    const magicIsZip =
      bytes.length >= 4 &&
      bytes[0] === 0x50 &&
      bytes[1] === 0x4b &&
      bytes[2] === 0x03 &&
      bytes[3] === 0x04; // ZIP (xlsx/xlsm/docx)


    const directDownload = (blobToSave, fallbackExt = "bin") => {
      const inferredName =
        fileNameFromHeader ||
        `${baseName}.${fallbackExt}`;

      const url = URL.createObjectURL(blobToSave);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", inferredName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
const isVerySmall = blob.size < 200;
    const probablyNotAFile =
      !isPdfByHeader && !isExcelByHeader && !magicIsPdf && !magicIsZip;

    if (isVerySmall && probablyNotAFile) {
      try {
        const text = new TextDecoder().decode(bytes);
        if (text?.toLowerCase().includes("no data")) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }
      } catch {}
      alert("No Data Available");
      setIsloading(false);
      return;
    }

    if (isPdfByHeader || magicIsPdf) {
      directDownload(
        new Blob([arrayBuffer], { type: "application/pdf" }),
        "pdf",
      );
      setIsloading(false);
      return;
    }

    if (isExcelByHeader || magicIsZip) {
 
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet =
        workbook.getWorksheet(1) ||
        workbook.worksheets?.[0]; 

      await addStampImagesToWorksheet(workbook, worksheet, request);

      const outBuffer = await workbook.xlsx.writeBuffer();
      const outBlob = new Blob([outBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const inferredName =
        fileNameFromHeader ||
        `${baseName}.xlsx`;

      const url = URL.createObjectURL(outBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", inferredName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setIsloading(false);
      return;
    }

 
    directDownload(blob, "dat");
    setIsloading(false);
  } catch (error) {
    console.error("Download failed:", error);
    alert("Download failed: " + (error?.message || "Unknown error"));
    setIsloading(false);
  }
};

//  const downloadApi = async (request) => {
//     try {
//       setIsloading(true);
//       const response = await axios({
//         method: "post",
//         url: VAVE + DOWNLOADIL5FILE,
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         data: { idea_id: request.idea_id },
//         responseType: "blob",
//       });

//       if (response.data.size === 14) {
//         alert("No Data Available");
//         setIsloading(false);
//         return;
//       }

//       // Load the uploaded Excel file
//       const workbook = new ExcelJS.Workbook();
//       const arrayBuffer = await response.data.arrayBuffer();
//       await workbook.xlsx.load(arrayBuffer);

//       const worksheet = workbook.getWorksheet(1);

    
      

//       await addStampImagesToWorksheet(workbook, worksheet, request);
        
//       const buffer = await workbook.xlsx.writeBuffer();
//       const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute(
//         "download",
//         `Idea_${request.idea_unique_id}_IL5_adminReport.xlsx`,
//       );
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
//       setIsloading(false);
//     } catch (error) {
//       console.error("Download failed:", error);
//       alert("Download failed: " + error.message);
//       setIsloading(false);
//     }
//   };

  const ideaExcelDownloadSubmit = async () => {
    try {
      const dataToExport = filteredIdeas.length ? filteredIdeas : updatedRequests;

      const filteredData = dataToExport.map((item) => ({
        id: `SWON-${item?.id_x}`,
        idea_category: item?.idea_category || item?.idea_category_x || "",
        partno: item?.partno || "",
        part_description: item?.part_description || "",
        benefit:item.benefit,
        idea_effective:item.idea_effective,
        model:item.model,
        varient:item.varient,
        subvarient:item.subvarient,
        checked_by: item?.checked_by || "",
        checked_status: getPDOverallStatus(item),
        approved_by: item?.approved_by || "",
        approved_status: getQualityOverallStatus(item),      
        
      }));

      // Summary sheet (computed counts)
      const summaryAOA = [
        ["Status Summary"],
        ["", "Checked", "Approved"],
        ["Approved", counts.checkedApproved, counts.approvedApproved],
        ["Pending", counts.checkedPending, counts.approvedPending],
         ["Rejected", counts.checkedRejected, counts.approvedRejected],
      ];

      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.aoa_to_sheet(summaryAOA);
      XLSX.utils.book_append_sheet(workbook, summarySheet, "IL5-Summary");

      const ideasSheet = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(workbook, ideasSheet, "Ideas");

      XLSX.writeFile(workbook, "IL5-Approvers.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };


// const ideaExcelDownloadSubmit = async () => {
//   try {
//     const dataToExport = filteredIdeas.length ? filteredIdeas : updatedRequests;

//     const filteredData = dataToExport.map((item) => ({
//       id: `SWON-${item?.id_x}`,
//       idea_category: item?.idea_category || item?.idea_category_x || "",
//       partno: item?.partno || "",
//       part_description: item?.part_description || "",
//       checked_by: item?.checked_by || "",
//       checked_status: getPDOverallStatus(item),
//       approved_by: item?.approved_by || "",
//       approved_status: getQualityOverallStatus(item),
//     }));

//     // 1️⃣ Create workbook
//     const workbook = XLSX.utils.book_new();

//     // 2️⃣ Create Summary sheet
//     const summaryAOA = [
//       ["Status Summary"],
//       ["", "Checked", "Approved"],
//       ["Approved", counts.checkedApproved, counts.approvedApproved],
//       ["Pending", counts.checkedPending, counts.approvedPending],
//       ["Rejected", counts.checkedRejected, counts.approvedRejected],
//     ];

//     const summarySheet = XLSX.utils.aoa_to_sheet(summaryAOA);
//     XLSX.utils.book_append_sheet(workbook, summarySheet, "IL5-Summary");

//     // 3️⃣ Create Ideas sheet
//     const ideasSheet = XLSX.utils.json_to_sheet(filteredData);
//     XLSX.utils.book_append_sheet(workbook, ideasSheet, "Ideas");

//     // 4️⃣ Add stamps to the Ideas sheet
//     // Assume "request" represents a single idea item
//     await addStampImagesToWorksheet(workbook, ideasSheet, request);

//     // 5️⃣ Save file
//     XLSX.writeFile(workbook, "IL5-Approvers.xlsx");
    
//   } catch (error) {
//     console.error("Error generating Excel:", error);
//   }
// };


  const addStampImageToCell = async (
    workbook,
    worksheet,
    row,
    col,
    isApproved,
  ) => {
    try {
      const imageUrl = isApproved ? approvedImage : rejectedImage;

      // Convert the imported image to a blob URL or base64
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();

      const imageId = workbook.addImage({
        buffer: arrayBuffer,
        extension: "png",
      });

      worksheet.addImage(imageId, {
        tl: { col: col - 1, row: row - 1, offset: 2 }, // 2px offset from top-left
        br: { col: col, row: row, offset: 2 }, // 2px offset from bottom-right
      });
    } catch (error) {
      console.error("Error adding stamp image:", error);
    }
  };

  const addStampImagesToWorksheet = async (workbook, worksheet, idea) => {
    try {
      console.log("Adding stamp images to worksheet");

      
      if (
        idea.checked_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.checked_status.toLowerCase() === "accepted" ||
          idea.checked_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 30, 7, isApproved); // H68
      }
    if (
        
        idea.prepared_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.prepared_status.toLowerCase() === "accepted" ||
          idea.prepared_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 30, 4, isApproved); // H68
      }
    
      if (
        idea.approved_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.approved_status.toLowerCase() === "accepted" ||
          idea.approved_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 30, 10, isApproved); // J68
      }

    
      console.log("Stamp images added successfully");
    } catch (error) {
      console.error("Error adding stamp images:", error);
    }
  };

  return (
    <div className="container mt-2">
      {/* Loader overlay */}
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : null}

      {/* Top Bar */}
      <div className="row align-items-center pb-3 pt-2 g-3">
        <div className="col-12 col-md-7 col-lg-7">
          <div className="d-flex align-items-center gap-3 flex-wrap justify-content-md-start">
            <div className="d-flex align-items-center">
              <label className="me-2">Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ width: "200px" }}
              />
            </div>

            <button
              type="button"
              className="btn btn-primary"
              onClick={ideaExcelDownloadSubmit}
            >
              Download (Total Ideas: {allIdeas.length})
            </button>
          </div>
        </div>

        {/* Status Summary */}
        <div className="col-12 col-md-5 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-header py-2">
              <strong>Status Summary</strong>
            </div>
            <div className="card-body p-0">
              <table className="table table-sm table-bordered mb-0 align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "40%" }}></th>
                    <th className="text-center">Checked</th>
                    <th className="text-center">Approved</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "green",
                          marginRight: 8,
                        }}
                      />
                      Approved
                    </td>
                    <td className="text-center">{counts.checkedApproved}</td>
                    <td className="text-center">{counts.approvedApproved}</td>
                  </tr>

                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "red",
                          marginRight: 8,
                        }}
                      />
                      Rejected
                    </td>
                    <td className="text-center">{counts.checkedRejected}</td>
                    <td className="text-center">{counts.approvedRejected}</td>
                  </tr>

                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "orange",
                          marginRight: 8,
                        }}
                      />
                      Pending
                    </td>
                    <td className="text-center">{counts.checkedPending}</td>
                    <td className="text-center">{counts.approvedPending}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Main Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              <th>IL5 Admin Excel</th>
              <th>Idea Category</th>
              <th>Checked by</th>
              <th>Approved by</th>
              <th>Checked Status</th>
              <th>Approved Status</th>
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.map((req) => {
              const pdApprover = req.approvers.find((a) => a.role === "CHECKED");
              const qualityApprover = req.approvers.find((a) => a.role === "APPROVED");

              return (
                <tr key={req.id_x}>
                  <td>{req.idea_unique_id || `SWON-${req.id_x}`}</td>
                   <td
                    style={{ cursor: "pointer" }}
                    onClick={() => downloadApi(req)}
                  >
                    <DownloadIcon />
                  </td>
                  <td>{req.idea_category || req.idea_category_x || "-"}</td>
                  <td>{req.checked_by || "-"}</td>
                  <td>{req.approved_by || "-"}</td>

                  {/* PD Status */}
                  <td>
                    {pdApprover ? (
                      <StatusDot
                        status={pdApprover.status}
                        name="CHECKED"
                        onClick={() => handleDotClick(req, pdApprover)}
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* Quality Status */}
                  <td>
                    {qualityApprover ? (
                      <StatusDot
                        status={qualityApprover.status}
                        name="APPROVED"
                        onClick={() => handleDotClick(req, qualityApprover)}
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* View more */}
                  <td style={{ cursor: "pointer" }} onClick={() => handleViewMore(req)}>
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* View More Dialog */}
      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                  <strong>Employee Id:</strong> {selectedIdea.emp_id}
                </Typography>
                <Typography variant="body1">
                  <strong>Employee Email:</strong> {selectedIdea.emp_email}
                </Typography>
                <Typography variant="body1">
                  <strong>Sw.No:</strong> {selectedIdea.idea_unique_id || `SWON-${selectedIdea.id_x}`}
                </Typography>
                <Typography variant="body1">
                  <strong>Idea Category:</strong>{" "}
                  {selectedIdea.idea_category || selectedIdea.idea_category_x || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong>{" "}
                  {selectedIdea.proposed_idea || selectedIdea.proposed_idea_x || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Drawing No:</strong>{" "}
                  {selectedIdea.drawing_no || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>ECN EDIN:</strong> {selectedIdea.ecn_edin || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Vin No:</strong> {selectedIdea.vin_no || "-"}
                </Typography>
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location || "-"}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    <button
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        border: "transparent",
                        background: "transparent",
                        textDecoration: "underline",
                        padding: 0,
                      }}
                      onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                    >
                      Download File
                    </button>
                  ) : (
                    "No File"
                  )}
                </Typography>

               
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pagination */}
      <Stack alignItems="center" marginTop={2}>
        <Pagination
          count={totalPages || 1}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </Stack>
    </div>
  );
};

export default IdeaTable;
